import Lenis from "lenis";

let lenisInstance = null;

export function getLenis() {
  return lenisInstance;
}

export function initLenis() {
  if (lenisInstance) return lenisInstance;
  lenisInstance = new Lenis({
    duration: 1.15,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
  });
  function raf(time) {
    lenisInstance.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  if (typeof window !== "undefined") window.__lenis = lenisInstance;
  return lenisInstance;
}

export function scrollToId(id, offset = -80) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
